import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ButtonIconsComponent} from './components/button-icons/button-icons.component';
import {RightBottomIconService} from './right-bottom-icon.service';
import {PortalModule} from '@angular/cdk/portal';


@NgModule({
            declarations: [ButtonIconsComponent],
            exports: [ButtonIconsComponent],
            imports: [
              CommonModule,
              PortalModule
            ],
            providers:    [RightBottomIconService]
          })
export class BottomIconModule {
}
